import { MutationTree } from "vuex";
import { Historic, HistoricMutations, HistoricState } from "./interface";
import { HistoricMutationsTypes } from "./types";

export const mutations: MutationTree<HistoricState> & HistoricMutations = {
  [HistoricMutationsTypes.SET_HISTORIC](state: HistoricState, payload: Array<Historic>): void {
    state.HistoricById = {};
    state.HistoricAllId = [];

    payload.forEach((role) => {
      state.HistoricById[role._id] = role;
      state.HistoricAllId.push(role._id);
    });
  }
};
